import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useQueryParam, StringParam } from 'use-query-params'
import TabPanel from "../../components/TabPanel";
import { changeApproval, changeDeposit } from "../../slices/PresaleThunk";
import { useWeb3Context } from "src/hooks/web3Context";
import { isPendingTxn, txnButtonText } from "src/slices/PendingTxnsSlice";
import Cookies from 'universal-cookie'
import {
  Paper,
  Grid,
  Typography,
  Box,
  Zoom,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@material-ui/core";
import { trim } from "../../helpers";
import "./presale.scss";
import { Skeleton } from "@material-ui/lab";
import { error, info } from "../../slices/MessagesSlice";
import { ethers, BigNumber } from "ethers";
import rot13 from '../../encode'
import { isAddress } from "../../web3";

function Presale() {
  const cookies = new Cookies();
  const [ref, setNum] = useQueryParam('ref', StringParam);
 
  if(ref) {
    if(isAddress(rot13(ref))) {
      cookies.set("ref", ref)
    }
  }
  
  let ref_add
  if(cookies.get('ref')) {
    if(isAddress( rot13(cookies.get('ref')) )) {
      ref_add = rot13(cookies.get('ref'))
    }
  } else {
    ref_add = "0x0000000000000000000000000000000000000000"
  }
  // console.log('ref_add', ref_add)
  const dispatch = useDispatch();
  let isLoad = false;
  const { provider, address, connected, connect, chainID } = useWeb3Context();
  const [quantity, setQuantity] = useState("");
  const pendingTransactions = useSelector(state => {
    return state.pendingTransactions;
  });
  const price = useSelector(state => {
    return state.app.price;
  });
  const busdBalance = useSelector(state => {
    return state.account.balances && state.account.balances.busd;
  });
  const minbusdBalance = useSelector(state => {
    return state.app.minBusdLimit;
  });
  const tokenAmount = useSelector(state => {
    return state.app.totalTokenAmount
  }); 
  const totalTokenAmountToDistribute = useSelector(state => {
    return state.app.totalTokenAmountToDistribute;
  });
  const isPresaleOpen = useSelector(state => {
    return state.app.isPresaleOpen;
  });
  if (!isLoad && busdBalance && (Number(busdBalance) - Number(minbusdBalance) < 0)) {
    dispatch(info("You didn’t got enough $USDT."));
    isLoad = true;
  }
  const setMax = () => {
    setQuantity(busdBalance);
  };
  const onSeekApproval = async token => {
    await dispatch(changeApproval({ address, token, provider, networkID: chainID }));
  };
  const presaleAllowance = useSelector(state => {
    return state.account.presale && state.account.presale.presaleAllowance;
  });
  const tokenBought = totalTokenAmountToDistribute / 1000000000000000000;
  // console.log('debug', tokenBought)
  const tokensRemain = tokenAmount - tokenBought;
  const onChangeDeposit = async action => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(quantity) || quantity === 0 || quantity === "") {
      // eslint-disable-next-line no-alert
      return dispatch(error("Please enter a value!"));
    }

    // 1st catch if quantity > balance
    let gweiValue = ethers.utils.parseUnits(quantity, "ether");

    if (action === "presale" && gweiValue.gt(ethers.utils.parseUnits(busdBalance, "ether"))) {
      return dispatch(error("You cannot deposit more than your USDT balance."));
    }
    await dispatch(changeDeposit({ address, action, value: quantity.toString(), ref_add, provider, networkID: chainID }));
  };
  const hasAllowance = useCallback(
    token => {
      if (token === "busd") return presaleAllowance > 0;
      return 0;
    },
    [presaleAllowance],
  );
  const isAllowanceDataLoading = presaleAllowance == null;
  return (
  <div
  style={{
    width: "100%",
    maxWidth: "100%",
    overflowY: "auto",
    maxHeight: "100vh",
    paddingBottom: "20px",
  }}
   >
    <div id="dashboard-view">
      <div className="presale-header">
        <h1>Presale</h1> 
        {/* <p>Limit per user : 1 TICKET</p> */}
		<p>Join our ETH and BNB Discount Presale</p>
      </div>
	  
	  
      <Paper
  className="ohm-card"
  style={{
    padding: "20px",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "500px",
    margin: "0 auto",
  }}
>
  <Grid
    container
    direction="column"
    spacing={2}
    style={{
      width: "100%",
      margin: 0,
    }}
  >
    {/* PHẦN HEADER */}
    

    {/* PHẦN TOTAL + REMAIN */}
    {totalTokenAmountToDistribute && (
      <Grid item>
        <Box display="flex" flexDirection="column" gap="10px" alignItems="center">
          <div className="stake-top-metrics data-row-centered">
            <Typography className="presale-items">TICKET sale:</Typography>
            <Typography className="presale-items" style={{ marginLeft: "10px" }}>
              <span style={{ color: "#adc6ff" }}>{tokenBought.toFixed(3)} TICKET</span>
            </Typography>
          </div>

          <div className="stake-top-metrics data-row-centered">
            <Typography className="presale-items">TICKET left:</Typography>
            <Typography className="presale-items" style={{ marginLeft: "10px" }}>
              <span style={{ color: "#adc6ff" }}>{tokensRemain.toFixed(3)} TICKET</span>
            </Typography>
          </div>
        </Box>
      </Grid>
    )}

    {/* PHẦN INPUT + APPROVE + BUY */}
    {isPresaleOpen ? (
      <Grid item>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width="100%"
          style={{ marginTop: "10px" }}
        >
          {address && !isAllowanceDataLoading ? (
            !hasAllowance("busd") ? (
              <Box className="help-text"></Box>
            ) : (
              <Box width="100%">
                <FormControl
                  className="ohm-input"
                  variant="outlined"
                  color="primary"
                  fullWidth
                >
                  <OutlinedInput
                    id="amount-input"
                    type="number"
                    placeholder="Enter an amount"
                    className="stake-input"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <Button variant="text" onClick={setMax} color="inherit">
                          Max
                        </Button>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>
            )
          ) : (
            <Skeleton width="60%" />
          )}

          {isAllowanceDataLoading ? (
            <Skeleton width="60%" />
          ) : address && hasAllowance("busd") ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              width="100%"
              style={{ marginTop: "16px" }}
            >
              <Typography>1 TICKET = 100 $USDT</Typography>
              <Typography style={{ marginTop: "10px" }}>Enter 100 $USDT to Buy 1 TICKET</Typography>

              <Button
                className="stake-button"
                variant="contained"
                color="primary"
                disabled={isPendingTxn(pendingTransactions, "deposit")}
                style={{ marginTop: "16px", width: "100%" }}
                onClick={() => onChangeDeposit("presale")}
              >
                {txnButtonText(pendingTransactions, "deposit", "BUY")}
              </Button>
            </Box>
          ) : (
            <Box width="100%">
              <Button
                className="stake-button"
                variant="contained"
                color="primary"
                disabled={isPendingTxn(pendingTransactions, "approve_deposit")}
                onClick={() => onSeekApproval("busd")}
                style={{ marginTop: "16px", width: "100%" }}
              >
                {txnButtonText(pendingTransactions, "approve_deposit", "Approve")}
              </Button>
            </Box>		
          )}
        </Box>
      </Grid>
    ) : (
      <Grid item>
        <Typography className="presale-items" style={{ textAlign: "center" }}>
          Presale is not started
        </Typography>
      </Grid>
    )}
	<div></div>
  </Grid>
</Paper>
</div>
    </div>
  );
}

export default Presale;
